// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"eb4e3c3c","300":"eb4e3c3c","506":"f7c62d14","576":"eb4e3c3c"}[chunkId] + ".chunk.css";
};